import { StateModel } from './../../../shared/models/state';
import { GeographyModel } from './../../../shared/models/geography';
import { ChannelModel } from './../../../shared/models/channel';
import { RegionModel } from './../../../shared/models/region';
import { MysteryCampaignAssignedModel, MysteryCampaignModel, WhitelistUsersDateRangeModel } from './../../../shared/models/mystery-shopper';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { USER_PONITS_HEADER } from 'src/app/hubadmin/shared/models/mock-data';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ExcelModel } from 'src/app/hubadmin/shared/models/geography';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, THEME } from 'ng-wizard';
import { of } from 'rxjs';
import { UserDetailModel } from 'src/app/hubadmin/shared/models/User';
import { RegionProvider } from 'src/app/hubadmin/shared/providers/region.provider';
import { ChannelProvider } from 'src/app/hubadmin/shared/providers/channel.provider';
import { GeographyProvider } from 'src/app/hubadmin/shared/providers/geography.provider';
import { StateProvider } from 'src/app/hubadmin/shared/providers/state.provider';

@Component({
  selector: 'app-add-edit',
  templateUrl: './add-edit.component.html',
  styleUrls: ['./add-edit.component.scss']
})
export class AddEditComponent implements OnInit {
  _form: FormGroup;
  submitted = false;
  mysteryUsers: UserDetailModel[];
  id: number;
  headerText: string = "Add";
  page: any = 1;
  statusDropdown: any[];
  @Input() model: MysteryCampaignModel = new MysteryCampaignModel();
  @Input() model1: MysteryCampaignAssignedModel = new MysteryCampaignAssignedModel();
  AssignedUsers: WhitelistUsersDateRangeModel[];
  searchRecords: MysteryCampaignAssignedModel[];
  campaignMysteryRecords: MysteryCampaignAssignedModel[];
  tempOptionModel: any;
  submittedLevels: any = { isSubmitted: true, state: "engagement" };
  getPaginationCount;
  excel: ExcelModel = new ExcelModel();
  excel1: ExcelModel = new ExcelModel();
  config: NgWizardConfig = {
    // selected: 0,
    anchorSettings: { anchorClickable: true },
    theme: THEME.default,
  };
  private _parameters: any;

  regionList: RegionModel[];
  channelList: ChannelModel[];
  geography: GeographyModel[];
  states: StateModel[];
  submitted6: boolean;
  reassignForm: FormGroup;
  assignForm: FormGroup;
  constructor(public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private formateDate: DateFormateService,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private xlsx: XlsxService,
    private modalService: NgbModal,
    private uploadFile: UploadZipService,
    public ngWizardService: NgWizardService,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider) {
    this._form = this.formBuilder.group({
      mystery_campaign_name: ["", Validators.required],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
    });

    this.assignForm = formBuilder.group({
      user: ['', Validators.compose([Validators.required])],
      // endate: ['', Validators.compose([Validators.required])],
      // startdate: ['', Validators.compose([Validators.required])],
    });

    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getAssignedUsers();
      }
    });


    this.reassignForm = formBuilder.group({
      user: ['', Validators.compose([Validators.required])],
      // endate: ['', Validators.compose([Validators.required])],
      // startdate: ['', Validators.compose([Validators.required])],
    });

  }

  ngOnInit() {
    this.statusDropdown = [{ id: 3, name: 'Not Assigned' }, { id: 1, name: 'Assigned' }, { id: 2, name: 'Completed' }];
    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.id = Number.parseInt(params["id"]);
          this.getMysteryAuditConfig(this.id);
          this.getAllMysteryCampaign();
          this.headerText = "Edit";
          this.getAssignedUsers();
          this.getMysteryOutletUsers();
          this.getAllMysteryUsers();
        }
      }
    });

    this.selectedChannel = "";
    this.selectedGeography = "";
    this.searchByStatus = "";
    this.searchByCampaign = "";
  }




  ngDoCheck() {
    this.regionList = this.regionProviders.regions;
    this.channelList = this.channelProviders.channels;
    this.geography = this.geoProviders.geography;
    this.states = this.stateProviders.state;
  }

  getAssignedUsers() {
    this.apiService
      .getHeaders(this.apiConfig.whiteOutlistMysteryCampaign + "?config_id=" + this.id + "&page=" + this.page)
      .subscribe(
        (res: any) => {
          if (res.body.data) {
            this.AssignedUsers = res.body.data;
            this.getPaginationCount = res.headers.get(
              "X-Pagination-Total-Count"
            );
            if (this.AssignedUsers.length > 0) {
              this.AssignedUsers.forEach(
                a => {
                  a.show = false;
                  a.statusString = a.status == 1 ? "Active" : "Inactive";
                  if (this.model.show == true) {
                    a.show = true;
                  }
                }
              )
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getAllUsers(pageNumber, data) {
    this.apiService
      .getHeaders(
        this.apiConfig.allUsers +
        "?page=" +
        pageNumber +
        "&search_string=" +
        data.search_string +
        "&geographical_id=" +
        data.geography +
        "&user_role_id=" +
        7 +
        "&state_code=" +
        data.states +
        "&region_id=" +
        data.regions +
        "&city=" +
        data.city
      )
      .subscribe(
        (res: any) => {
          this.mysteryUsers = res.body.data;
          if (this.mysteryUsers.length > 0) {
            this.mysteryUsers.forEach((i) => {
              i.isEdit = false;
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getMysteryOutletUsers() {
    this.apiService
      .getHeaders(this.apiConfig.getMysteryCampaignOutlets + "?config_id=" + this.id)
      .subscribe(
        (res: any) => {
          if (res.body.data) {
            this.campaignMysteryRecords = res.body.data;;
            this.searchRecords = res.body.data;
            this.campaignMysteryRecords.forEach(
              r => {
                r.showCheckBox = false;
                r.bulkChecked = false;
                r.reassign = false;
                r.campaign_end_date = new Date(r.campaign_end_date);
                if (new Date(r.end_date) >= new Date()) {
                  r.reassign = true;
                }
              }
            )
            this.searchRecords.forEach(
              r => {
                r.showCheckBox = false;
                r.bulkChecked = false;
                r.reassign = false;
                if (new Date(r.end_date) >= new Date()) {
                  r.reassign = true;
                }
              }
            )
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getMysteryAuditConfig(id) {
    this.apiService
      .getHeaders(this.apiConfig.getAllMysteryCampaign + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.model = res.body.data as MysteryCampaignModel;
          this.model.show = false;
          this.model.statusString = (this.model.status == 1) ? "Active" : "Inactive";
          if (new Date(this.model.start_date) >= new Date()) {
            this.model.show = true;
          }
          let dates = {
            start: this.model.start_date.split("-"),
            end: this.model.end_date.split("-"),
          };
          let startDate = {
            year: parseInt(dates.start[0]),
            month: parseInt(dates.start[1]),
            day: parseInt(dates.start[2]),
          };
          let endDate = {
            year: parseInt(dates.end[0]),
            month: parseInt(dates.end[1]),
            day: parseInt(dates.end[2]),
          };
          this.model.startDate = startDate;
          this.model.endDate = endDate;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getAllMysteryCampaign() {
    this.apiService.getHeaders(this.apiConfig.getAllMysteryCampaign)
      .subscribe((res: any) => {
        this.mysteryCampaign = res.body.data;
      }, err => {
        console.log(err);
      })
  }



  // convenience getters for easy access to form fields
  get f() {
    return this._form.controls;
  }

  get f6() {
    return this.reassignForm.controls;
  }

  get f5() {
    return this.assignForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this._form.invalid) {
      return;
    }
    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);
    if (this.model.id != null) {
      this.updateMysteryAudit();
    } else {
      this.createMysteryAudit();
    }
  }

  createMysteryAudit() {
    this.apiService
      .post(this.apiConfig.createMysteryCampaign, this.model)
      .subscribe((res: any) => {
        if (res.body.status) {
          this.alertService.success(res.body.data.message);
          this.id = res.body.data.id;
          this.showNextStep();
        }
      });
  }

  updateMysteryAudit() {
    this.apiService
      .put(
        this.apiConfig.updateMysteryCampaign + "?id=" + this.model.id,
        this.model
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.showNextStep();
        }
      });
  }

  reset() {
    this._form.reset();
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  changeUserStatus(item: any) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateWhiteOutlistMysteryCampaign + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
      });
  }

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  downloadExcel() {
    this.exportExcelService.exportUserAssignment();
  }

  downloadExcel1() {
    this.exportExcelService.exportMysteryUserExcel(this.mysteryUsers);
  }

  closeoptionModel() {
    this.tempOptionModel.close();
  }

  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }

  uploadXlsx1(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView1(res);
    });
  }


  xlsxView1(data) {
    data.apiHeaders = USER_PONITS_HEADER;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel1.excel_data = result;
          this.uploadMultiData1(this.excel1);
        }
      },
      (reason) => { }
    );
  }

  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.uploadMultiData(this.excel);
        }
      },
      (reason) => { }
    );
  }

  uploadMultiData(data) {
    data.excel_data.filter(i => {
      i["rocode"] = i["Outlet Code"]
      delete i["Outlet Code"];
      delete i.isEdit;
    })
    let payload = {
      "module_campaign_id": this.id,
      "users": data.excel_data
    }
    console.log(payload)
    this.enableUploadDiv(payload);
  }

  uploadMultiData1(data) {
    let payload = {
      "module_campaign_id": this.id,
      "users": data.excel_data
    }
    console.log(payload)
    this.enableUploadDiv1(payload);
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.BulkLoadMysteryUser,
      module: "User Assigment",
      zip: "no",
      excelname: "User Assignment Excel",
    });
  }

  enableUploadDiv1(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.ImportAssignOutlets,
      module: "User Assigment",
      zip: "no",
      excelname: "User Assignment Excel",
    });
  }

  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getAssignedUsers();
  }


  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.submittedLevels.state = args.step.index;
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  onReset() {
    // reset whole form back to initial state
    this.submitted = false;
    this._form.reset();
  }

  onClear() {
    // clear errors and reset ticket fields
    this.submitted = false;
    this._form.reset();;
  }

  /**************Assignment****************/

  error: any = { isError: false, errorMessage: '' };

  error1: any = { isError: false, errorMessage: '' };

  searchByStatus: any;
  searchByCampaign: any;
  mysteryCampaign: any[];
  selectedGeography: any;
  selectedChannel: any;

  searchData() {
    this.campaignMysteryRecords = this.searchRecords;

    if (this.searchByStatus != "" && this.searchByStatus != null) {
      if (this.searchByStatus != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.status == parseInt(this.searchByStatus));
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.searchByCampaign != "" && this.searchByCampaign != null) {
      if (this.searchByCampaign != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.mystery_campaign_id == this.searchByCampaign);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.selectedGeography != "" && this.selectedGeography != null) {
      if (this.selectedGeography != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.region_id == this.selectedGeography);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.selectedChannel != "" && this.selectedChannel != null) {
      if (this.selectedChannel != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.channel_id == this.selectedChannel);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }
  }

  searchText: string;

  bulkButton: boolean;
  bulkRecords: MysteryCampaignAssignedModel[];

  filterListOfRecords() {
    this.campaignMysteryRecords = this.searchRecords;

    if (this.searchByStatus != "" && this.searchByStatus != null) {
      if (this.searchByStatus != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.status == parseInt(this.searchByStatus));
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.searchByCampaign != "" && this.searchByCampaign != null) {
      if (this.searchByCampaign != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.mystery_campaign_id == this.searchByCampaign);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.selectedGeography != "" && this.selectedGeography != null) {
      if (this.selectedGeography != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.region_id == this.selectedGeography);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

    if (this.selectedChannel != "" && this.selectedChannel != null) {
      if (this.selectedChannel != 0) {
        this.campaignMysteryRecords = this.campaignMysteryRecords.filter(f => f.channel_id == this.selectedChannel);
      }
      else {
        this.campaignMysteryRecords = this.searchRecords;
      }
    }

  }

  checkedEvent: boolean = false;

  BulkAll() {
    this.checkedEvent = !this.checkedEvent;
    if (typeof this.checkedEvent != "undefined") {
      if (this.checkedEvent == true) {
        this.selectAll();
      }
      else {
        this.DeselectAll();
      }
    }
  }

  selectAll() {

    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.bulkChecked = true;
        }
      }
    );
    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.bulkChecked = true;
        }
      }
    );
  }

  DeselectAll() {
    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.bulkChecked = false;
        }
      }
    );
    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.bulkChecked = false;
        }
      }
    );
  }

  assignedUsers: any[];

  openModal1(template1, item) {
    this.model1 = item;
    this.assignedUsers = this.mysteryUsers.filter(u => u.user_id != item.assigned_user_id);
    this.tempOptionModel = this.modalService.open(template1, {
      centered: true,
      // backdrop: 'static'
    });

  }

  getAllMysteryUsers() {
    this.apiService
      .getHeaders(
        this.apiConfig.allUsers +
        "?user_role_id=" +
        7
      )
      .subscribe(
        (res: any) => {
          this.mysteryUsers = res.body.data;
          if (this.mysteryUsers.length > 0) {
            this.mysteryUsers.forEach((i) => {
              i.isEdit = false;
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  onSubmitReassign() {

  }


  editAssignRecord() {

    this.submitted6 = true;
    this.error1 = {};

    if (this.reassignForm.invalid) {
      return;
    }


    if (typeof this.model1 != "undefined") {
      let body = {
        'assigned_id': this.model1.assigned_id,
        'record': this.model1,
      };
      this.apiService.post(this.apiConfig.editMysteryAssignment, body)
        .subscribe(
          (response: any) => {
            this.toast.Success(`Outlet ${this.model1.outlet_name}
            record has been updated successfully for the audit
              between ${this.model1.start_date} to ${this.model1.end_date}`);
            this.getMysteryOutletUsers();
          },
          error => {
            this.alertService.error(error);
          }
        )
    }
  }
  bulkBtnStatus: boolean;
  openModalWithClass() {
    console.log('Bulk Assign Clicked');
    let data = this.campaignMysteryRecords.filter(r => r.status == 3);
    if (data.length > 0) {
      this.bulkButton = this.bulkBtnStatus = true;
      this.bulkAssignedBtnfun();
    }
    else {
      this.toast.Error(`No Request to assign`);
    }
  }

  bulkAssignedBtnfun() {
    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.showCheckBox = true;
        }
      }
    );
    this.campaignMysteryRecords.forEach(
      r => {
        if (r.status == 3) {
          r.showCheckBox = true;
        }
      }
    );
  }

  maxDate: any;

  bulkModal(template1) {
    this.bulkRecords = this.campaignMysteryRecords.filter(r => r.bulkChecked == true);
    let date = this.mysteryCampaign.find(f => f.id == this.searchByCampaign).end_date;
    this.maxDate = new Date(date);
    if (this.bulkRecords.length > 0) {
      this.tempOptionModel = this.modalService.open(template1, {
        centered: true,
      });
    }
    else {
      let message = "Please select outlet to assign";
      this.toast.Error(`${message}`);
      this.alertService.error(`${message}`);
      this.clearSuccess();
    }
  }
  disableAssignBulk: boolean = false;
  bulkUser: number;
  cancelBulkAssign() {
    this.bulkRecords = undefined;
    this.bulkUser = undefined;
    this.cancelBulkChecked();
    this.bulkButton = this.bulkBtnStatus = false;
  }

  cancelBulkChecked() {
    this.campaignMysteryRecords.forEach(
      r => {
        r.showCheckBox = false;
        r.bulkChecked = false;
      }
    );

    this.campaignMysteryRecords.forEach(
      r => {
        r.showCheckBox = false;
        r.bulkChecked = false;
      }
    );
  }

  submitted5: boolean;

  assignBulkRecord() {
    this.submitted5 = true;
    this.error = {};
    this.bulkUser = this.assignForm.controls['user'].value;
    // if (new Date(this.assignForm.controls['endate'].value).setHours(0, 0, 0, 0) < new Date(this.assignForm.controls['startdate'].value).setHours(0, 0, 0, 0)) {
    //   this.error = { isError: true, errorMessage: 'End Date can\'t before Start date' };
    // }

    if (this.error.isError) {
      return;
    }
    if (this.assignForm.invalid) {
      return;
    }
    if (this.bulkRecords.length > 0) {
      console.log(this.bulkRecords);
      let users = this.bulkRecords.map(i => i.outlet_id);
      let lastDate = null;
      let startDate = null;
      console.log(`Bulk Assigned User ${this.bulkUser}`);
      this.BulkAssign(users, this.bulkUser, lastDate, startDate, this.searchByCampaign);
      this.mysteryUsers.forEach(
        f => {
          if (f.user_id == this.bulkUser) {
            this.bulkRecords.forEach(
              b => {
                b.mystery_shopper_user_name = f.user_detail_name;
                b.mystery_shopper_user_id = f.user_id;
                b.end_date = lastDate;
                b.status = 1;
                b.outlet_status = 'Assigned';
                b.mystery_shopper_mobile_number = f.username;
              }
            )
          }
        }
      );
      this.cancelBulkAssign();
    }
    else {
      let message = "Please Select Outlet to assign";
      this.toast.Error(`${message}`);
      this.alertService.error(message);
      this.clearSuccess();
    }
  }

  BulkAssign(records, user, end_date, start_date, campaign_id) {
    let body = {
      'assigned_user_id': user,
      'records': records,
      'end_date': end_date,
      'start_date': start_date,
      'campaign_id': campaign_id
    };
    this.apiService.post(this.apiConfig.bulkAssignOutlets, body)
      .subscribe(
        (response: any) => {
          let message = `${records.length} Outlets has been assigned successfully for the audit
          between ${start_date} to ${end_date}`;
          this.toast.Success(message);
          this.alertService.success(message);
          this.clearSuccess();
          this.getMysteryOutletUsers();
        },
        error => {
          this.alertService.error(error);
        }
      )
  }

}
